export enum CheckListStatusEnum {
  Approved,
  WithChanges,
  ToPassOn,
}
